import { render, staticRenderFns } from "./BattleLayout.vue?vue&type=template&id=4a4950f8&scoped=true"
import script from "./BattleLayout.vue?vue&type=script&lang=js"
export * from "./BattleLayout.vue?vue&type=script&lang=js"
import style0 from "./BattleLayout.vue?vue&type=style&index=0&id=4a4950f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4950f8",
  null
  
)

export default component.exports